import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'sm-preview-pdf',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './preview-pdf.component.html',
})
export class PreviewPdfComponent implements OnInit, OnDestroy {
  @Input() src?: Observable<string>;
  @Input() height = '500px';
  @Input() isPdf = true;

  safeSrc?: SafeResourceUrl;
  private sub?: Subscription;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.sub = this.src?.subscribe(url => {
      this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
